import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import '../styles/Auth.css';

const FUNCTIONS_BASE = process.env.REACT_APP_FUNCTIONS_BASE || 'https://us-central1-up-convert.cloudfunctions.net';

function RepAuthCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Connecting your client email…');
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code || !state) {
      setError('Missing authorization details. Please try connecting the email again from your dashboard.');
      return;
    }

    const completeConnection = async () => {
      try {
        // Wait for auth to be ready
        const user = auth.currentUser;
        if (!user) {
          // Auth might not be loaded yet — wait a bit
          await new Promise((resolve) => {
            const unsub = auth.onAuthStateChanged((u) => {
              unsub();
              resolve(u);
            });
          });
        }

        const currentUser = auth.currentUser;
        if (!currentUser) {
          setError('You must be signed in to connect a client email. Please sign in and try again.');
          return;
        }

        setStatus('Linking email to your account…');
        const idToken = await currentUser.getIdToken();

        const res = await fetch(`${FUNCTIONS_BASE}/connectClientEmail`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
          body: JSON.stringify({ code, state }),
        });

        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.error || 'Failed to connect email');
        }

        const data = await res.json();
        setStatus(`Connected ${data.email}! Redirecting…`);

        // Redirect back to rep dashboard with success flag
        setTimeout(() => {
          navigate('/rep/dashboard?connected=true', { replace: true });
        }, 1000);
      } catch (err) {
        setError(err.message || 'Unable to connect the email account.');
      }
    };

    completeConnection();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <p className="eyebrow">Connecting email</p>
        <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: 24 }}>Client Email Setup</h1>
        {error ? (
          <>
            <p className="error-text" style={{ marginTop: 12 }}>{error}</p>
            <button
              type="button"
              className="primary-button"
              style={{ width: '100%', marginTop: 18 }}
              onClick={() => navigate('/rep/dashboard', { replace: true })}
            >
              Back to dashboard
            </button>
          </>
        ) : (
          <>
            <div className="loading-graphic" aria-hidden="true" />
            <p className="subhead" style={{ marginTop: 10 }}>{status}</p>
          </>
        )}
      </div>
    </div>
  );
}

export default RepAuthCallback;
